import { Directive, ElementRef, inject, Input, NgZone } from '@angular/core';
import { SbbSignetElement } from '@sbb-esta/lyne-elements/signet.pure.js';

/**
 * It displays the SBB signet.
 * @cssprop [--sbb-signet-height=auto] - Can be used to set the height of the signet.
 */
@Directive({
  selector: 'sbb-signet',
  exportAs: 'sbbSignet',
})
export class SbbSignet {
  static {
    SbbSignetElement.define();
  }

  #element: ElementRef<SbbSignetElement> = inject(ElementRef<SbbSignetElement>);
  #ngZone: NgZone = inject(NgZone);

  /**
   * Visual protective room around signet.
   */
  @Input()
  public set protectiveRoom(value: 'none' | 'minimal' | 'ideal' | 'panel') {
    this.#ngZone.runOutsideAngular(() => (this.#element.nativeElement.protectiveRoom = value));
  }
  public get protectiveRoom(): 'none' | 'minimal' | 'ideal' | 'panel' {
    return this.#element.nativeElement.protectiveRoom;
  }

  /**
   * Accessibility label which will be forwarded to the inner SVG signet.
   */
  @Input()
  public set accessibilityLabel(value: string) {
    this.#ngZone.runOutsideAngular(() => (this.#element.nativeElement.accessibilityLabel = value));
  }
  public get accessibilityLabel(): string {
    return this.#element.nativeElement.accessibilityLabel;
  }
}
